import styles from "./UploadGridItem.module.css";
import ElementsContextType from "../../types/ElementsContextType";
import { ElementsContext } from "../contexts/ElementsContext";
import { useSelector } from "react-redux";
import { AssetState } from "../../types/AssetState";
import React from "react";
import ElementAsset from "../../types/ElementAsset";

interface IDictionary {
    [index: string]: string;
}

const styleList = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
    single: styles.single,
    remaining: styles.remaining
} as IDictionary;

interface Props {
    image: ElementAsset;
    type: string;
    remaining?: string;
    components?: any;
    id: number;
    elementId: string;
}

export default function UploaderForImages({
    image,
    type,
    remaining,
    components,
    id,
    elementId
}: Props) {
    const { openGallery, openImageViewer } = React.useContext(
        ElementsContext
    ) as ElementsContextType;
    const activeInspection = useSelector(
        (state: any) => state.portal.activeInspection
    );
    let currentElement: any = undefined;
    let imageElement: any = {
        id: "N/A"
    };
    if (activeInspection !== undefined) {
        currentElement = activeInspection.sections.find(
            (section: any) => section.Id === elementId
        );
        imageElement = currentElement.Images[id];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const uploadList = useSelector((state: any) =>
        state.portal.uploadList.get(imageElement?.id)
    );

    function clickHandler() {
        if (remaining && currentElement) {
            openGallery(currentElement);
        } else if (currentElement) {
            openImageViewer(image, currentElement);
        }
    }

    const selectedStyle = styleList[type];
    const gridItemState =
        imageElement?.state !== undefined
            ? imageElement.state
            : AssetState.NO_ASSET;
    const uploadProgress =
        imageElement?.progress !== undefined ? imageElement.progress : 0;

    const componentProps = {
        clickHandler: clickHandler,
        uploadProgress: uploadProgress,
        remaining: remaining,
        selectedStyle: selectedStyle,
        shouldOpenGallery: true,
        element: currentElement,
        image: image
    };

    const gridItem = React.createElement(
        components[gridItemState],
        componentProps
    );

    return <div>{gridItem}</div>;
}
